import { AxiosRequestConfig } from 'axios';
import { ServiceName } from '@ygoargentina/helpers/services';
import { AppCommitHash, AppVersion } from '@/types';
import { layoutInitialState, useLayoutStore } from '@/store/layout';
import Config from '@/config';

export const axiosConfig = (): AxiosRequestConfig => {
  const { language } = useLayoutStore.getState() ?? layoutInitialState;

  return {
    headers: {
      'x-ygoarg-app-version': AppVersion,
      'x-ygoarg-app-hash': AppCommitHash,
      'x-ygoarg-service': ServiceName.FOLDER,
      'x-ygoarg-language': language,
    },
  };
};

export const axiosConfigWithTaskKey = () => {
  const config: AxiosRequestConfig = {};

  config.headers = {
    'x-ygoarg-app-version': AppVersion,
    'x-ygoarg-app-hash': AppCommitHash,
    'x-ygoarg-service': ServiceName.FOLDER,
    'tasks-api-key': Config.tasksApiKey,
  };

  return config;
};
